import { Reveal } from './Reveal';
import { ArrowLinkIcon } from './icons';

const POSTS = [
  {
    image: '/landing/blog-1.png',
    tag: 'SMS Marketing', tagBg: '#f0f9f6', tagColor: '#2ca342',
    title: 'Tips to Compose Better Messages & Avoid Violating Telco Policy',
    date: 'May 12, 2024',
  },
  {
    image: '/landing/blog-2.png',
    tag: 'SMS Marketing', tagBg: '#f0f9f6', tagColor: '#2ca342',
    title: 'Tips & Guideline for Creating Your Sender ID',
    date: 'May 12, 2024',
  },
  {
    image: '/landing/blog-3.png',
    tag: 'Airtime & Data', tagBg: '#feeae4', tagColor: '#f97d5a',
    title: 'How to use the Airtime & Data API',
    date: 'May 12, 2024',
  },
];

export function InsightsSection() {
  return (
    <section style={{ maxWidth: 1400, margin: '0 auto', padding: '80px 24px' }}>
      <Reveal>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 16, marginBottom: 48 }}>
          <div>
            <h2 style={{ margin: '0 0 8px', fontFamily: 'Inter, sans-serif', fontWeight: 700, fontSize: 24, color: '#000' }}>
              Insights and resources
            </h2>
            <p style={{ margin: 0, fontFamily: 'Inter, sans-serif', fontWeight: 500, fontSize: 15, color: '#4c5876' }}>
              Tips, guides and best practices to help you communicate better.
            </p>
          </div>
          <a href="#" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, textDecoration: 'none', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#014ed2', whiteSpace: 'nowrap' }}>
            View all Resources <ArrowLinkIcon size={18} />
          </a>
        </div>
      </Reveal>

      <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
        {POSTS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.1} y={30} scale={0.92} style={{ flex: '1 1 340px', maxWidth: 437 }}>
            <div style={{ borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 7px rgba(0,0,0,0.12)', background: '#fff' }}>
              <div style={{ position: 'relative', width: '100%', height: 160 }}>
                <img src={p.image} alt={p.title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
              <div style={{ padding: '18px 20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                  <span style={{ fontSize: 12, fontFamily: 'Inter, sans-serif', fontWeight: 500, background: p.tagBg, color: p.tagColor, borderRadius: 23, padding: '4px 14px' }}>
                    {p.tag}
                  </span>
                  <span style={{ fontSize: 12, fontFamily: 'Inter, sans-serif', color: '#4c5876' }}>{p.date}</span>
                </div>
                <p style={{ margin: '0 0 18px', fontFamily: 'Inter, sans-serif', fontWeight: 700, fontSize: 16, color: '#000', lineHeight: 1.4, minHeight: 44 }}>
                  {p.title}
                </p>
                <a href="#" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, textDecoration: 'none', fontSize: 14, fontFamily: 'Inter, sans-serif', fontWeight: 600, color: '#014ed2' }}>
                  Read more <ArrowLinkIcon size={18} />
                </a>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
